__turbopack_context__.v({
  "actions": "styles-module-scss-module__nQFXhq__actions",
  "banner": "styles-module-scss-module__nQFXhq__banner",
  "button": "styles-module-scss-module__nQFXhq__button",
  "content": "styles-module-scss-module__nQFXhq__content",
  "link": "styles-module-scss-module__nQFXhq__link",
  "text": "styles-module-scss-module__nQFXhq__text",
  "title": "styles-module-scss-module__nQFXhq__title",
});
